import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { endsWithSegment, startsWithSegment } from "router5-helpers";

import cx from "classnames";

import * as RoutingSelectors from "modules/routing/routing-selectors";
import GeneralInfo from "modules/general-info/general-info";
import Modal from "modules/modal/modal";
import SignUpPage from "modules/pages/SignUpPage";
import * as Routes from "modules/routing/routes";

import { getLocale } from "modules/i18n/locale-selectors";

import "styles/index.css";

import LoadingOverlay from "./loading-overlay";
import { getBrand } from "../brand/brand-selectors";

import BackgroundVideo from "./app-background-video";
import AppBackground from "./app-background";
import HomePage from "../pages/HomePage";
import AgeInfoPage from "../pages/AgeInfoPage";
import GuidanceSelfDiagnosisPage from "../pages/GuidanceSelfDiagnosisPage";
import ConsentPage from "../pages/ConsentPage";
import SelfDiagnosticFinishedPage from "../pages/SelfDiagnosticFinishedPage";
import GuidanceHumanBodyPage from "../pages/GuidanceHumanBodyPage";

class App extends Component {
  static propTypes = {
    routeName: PropTypes.string
  };

  render() {
    const { routeName, locale, brand } = this.props;
    const endsWith = endsWithSegment(routeName);
    const startsWith = startsWithSegment(routeName);

    const routeParts = routeName.split(".");
    const rootClass = routeParts[routeParts.length - 1];
    const routeClass = routeName.replace(/\./g, "_");
    const mainClass = `App ${brand.baseClass}`;

    return (
      <Fragment>
        <BackgroundVideo />
        <AppBackground />

        <div className={cx(mainClass, rootClass, `route--${routeClass}`)}>
          {/*<aside className="Sidebar">
            <img className="OldLogo" src={Logo} alt="Healo Logo" onClick={this.goHome} />
            <nav className="NavMain">
              <button onClick={this.goHome}>Go home</button>
              <button onClick={() => goTo(Routes.SIGN_UP)}>
                <FormattedMessage id="root.sign-up" />
              </button>
            </nav>
          </aside>*/}
          {endsWith(Routes.INDEX) && <HomePage />}
          {startsWith(Routes.SIGN_UP) && <SignUpPage />}
          {endsWith(Routes.AGE_INFO) && <AgeInfoPage />}
          {endsWith(Routes.GUIDANCE_SELF_DIAGNOSTICS) && (
            <GuidanceSelfDiagnosisPage />
          )}
          {endsWith(Routes.CONSENT) && <ConsentPage />}
          {endsWith(Routes.SELF_DIAGNOSIS_FINISHED) && (
            <SelfDiagnosticFinishedPage />
          )}
          {endsWith(Routes.SELF_DIAGNOSIS_GENERAL_INFO) && (
            <div className="SelfDiagnosisPage">
              <GeneralInfo />
            </div>
          )}
          {endsWith(Routes.GUIDANCE_HUMAN_BODY) && <GuidanceHumanBodyPage />}
          <Modal lang={locale} />
        </div>
        <LoadingOverlay />
      </Fragment>
    );
  }
}

const mapState = state => ({
  routeName: RoutingSelectors.getCurrentRouteName(state),
  locale: getLocale(state),
  brand: getBrand(state)
});

const mapDispatch = {};

export default connect(
  mapState,
  mapDispatch
)(App);



// WEBPACK FOOTER //
// ./src/modules/root/root-component.js